import { camelCase as loCamelCase } from "lodash";
import { CamelCase } from "type-fest";

export function camelCase<T extends string>(str: T): CamelCase<T> {
  return loCamelCase(str) as CamelCase<T>;
}
